const settings = {
    logo: "Mizaem",
    logo_description: "Удобно получить займ в Казахстане",
    footer_text: " - Удобный подбор займов в Казахстане, 2020",
    title: "Mizaem - Удобный подбор займов в Казахстане",
    loan_value: "40000",

    lending_url: "https://mizaem.com.kz/",
    lending_name: "Mizaem.com.kz",

    favicon: "../logo/mizaem-small-logo.png",
    logo_img: "../logo/mizaem-small-logo.png",

    primary_color: "#009688",
    secondary_color: "#009688",
    anchor_color: "#2196F3",
    spinner_color: "#BDBDBD",

    gtm: "GTM-56QKDGH",

    yandex_metrika: "55447786",

    is_phone_required: false,
    is_email_required: false,
    is_surname_required: false,
    is_name_required: false,
    is_passport_required: false,
    is_password_required: false,

    default_password : "cFe4pmdcocyGeT7SdCpQsyLVs",

    skip_3_step: true,

    is_mailgun_ok: false,
    show_i_need: true,

    show_slider: true,
    default_possibility: 15,
    min_default_possibility: 12,
    max_default_possibility: 20,
    default_loanvalue: 40000,
    min_default_loanvalue: 20000,
    max_default_loanvalue: 200000,
    step: 1000,

    social_providers: [],

    show_additional_slogan: true,

    contact_email: "",

    enable_ads_reg: false,
    ads_reg_settings: {
        class: "adsbygoogle",
        style: "display:block",
        data_ad_client: "ca-pub-9730477386563882",
        data_ad_slot: "3192458488",
        data_ad_format: "auto",
        data_full_width_responsive: "true",
    },

    enable_ads_offers: false,
    ads_offers_settings: {
        placement: "bottom",
        class: "adsbygoogle",
        style: "display:block",
        data_ad_client: "ca-pub-9730477386563882",
        data_ad_slot: "7299773194",
        data_ad_format: "fluid",
        data_ad_layout_key: "-fb+5w+4e-db+86",
    },

    enable_second_ads_offers: false,
    second_ads_offers_settings: {
        class: "adsbygoogle",
        style: "display:block",
        data_ad_client: "ca-pub-9730477386563882",
        data_ad_slot: "7059281802",
        data_ad_format: "auto",
        data_full_width_responsive: "true",
    },

    payments: {
        enabled: false,
        registration: false,
        pass_registration: false,
        offer: false,
        subscription_confirm: false,
        subscription_confirm_required: false,

        registration_possibility: "",
        registration_help_text: "",
        offer_help_text: "",
        after_check_requisites: false,
    },
};

export default settings;
